import styled from 'styled-components';

export const FundCardStyle = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 40px 1fr 1fr;

  &.custom-report-type {
    grid-template-columns: 1fr 1fr;
  }

  .item {
    padding: 16px;
    background-color: #fff;
    border-bottom: 1px solid #f1f3f5;
    border-right: 1px solid #f1f3f5;
    // display: flex;
    // flex-direction: column;

    @media (max-width: 850px) {
      padding: 8px;
      min-width: 0;
    }

    &:last-child {
      border-right: none;
    }

    &.no-item {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      border-bottom: 1px solid #f1f3f5;
      border-left: 1px solid #f1f3f5;
      background: #f8f9fa;
      color: #adb5bd;
      text-align: center;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 140%; /* 19.6px */
    }

    .fund-header {
      margin-bottom: 16px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 22px;

      @media (max-width: 850px) {
        p.name {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          min-width: 0;
          flex: 1;
        }
      }

      .upload-file-btn {
        display: flex;
        align-items: center;
        gap: 12px;
        color: #228be6;
        font-size: 14px;
        line-height: 20px;
        border: none;
        background: transparent;
      }
      .name {
        color: #2b313d;
        font-size: 14px;
        font-weight: 500;
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
    }
  }
  .grid-columns-2 {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 24px;
  }
  .files {
    display: flex;
    flex-direction: column;
    gap: 16px;
    flex: 1;

    &.per-fund {
      border-top: 1px solid #f1f3f5;
      margin-top: 12px;
      padding-top: 12px;
    }

    .divider {
      width: 100%;
      height: 1px;
      background: #d1d5db;
      margin: 48px 0 15px;
    }
    .files-title {
      color: #5c5d61;
      font-size: 12px;
      font-weight: 500;
      margin-bottom: 6px;
    }
  }
`;
